import { service ,user} from 'eco-cli'

export const sendPhoneCode = (phone) => service.system.withToken.get('/sendSignOutCode', {
    phone: phone
})

export const phoneLogin = (phone, code) => service.system.withToken.get('/signOut', {
    // mobile: phone,
    captcha: code,
}).then(()=> user.logout() )
